export const iconFontAwesomeSportsFitnessPersonSkiingNordic = (
	<i className="fa-solid fa-person-skiing-nordic"></i>
);
